import React from "react";
import Modal from "../app/Modal";
import { connect } from "react-redux";
import * as actions from "../../actions";

import "./Customers.css";
import Chip from "@material-ui/core/Chip";

class Component extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      zohoAccessToken: "",
      zohoRefreshToken: ""
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleCloseReload = this.handleCloseReload.bind(this);
    this.handleCloseCustom = this.handleCloseCustom.bind(this);
  }

  componentDidMount() {
    this.props.fetchZohoCustomers();
  }

  handleOpen() {
    this.setState({ modalOpen: true });
  }

  handleClose() {
    this.setState({ modalOpen: false });
  }

  handleCloseReload = () => {
    this.setState({ modalOpen: false });
    this.props.reloadData();
  };

  handleCloseCustom = () => {
    this.setState({ modalOpen: false });
    this.props.doCustomAction();
  };

  render() {
    const renderCustomers = data => {
      let output = [];
      if (data) {
        output = data.map((record, index) => (
          <tr key={index}>
            <td>
              <strong>{record.display_name}</strong>
              <br />
              <div className="txt-inactive">{record.customer_id}</div>
            </td>
            <td>
              <Chip label={record.status} color="primary" />
            </td>
            <td>{record.payment_terms_label}</td>
            <td>
              {record.created_time}
              <br />
              {record.updated_time}
            </td>
          </tr>
        ));
      }
      return output;
    };

    return (
      <div className="component-menu pad-20">
        <div className="row">
          <div className="col s12">
            <div className="card grey darken-5">
              <div className="card-action">
                <span className="card-title">Customers</span>
              </div>
              <div className="card-content white-text">
                <div className="row">
                  <div className="col s12 txt-left">STATUS UPDATE</div>
                </div>
                <div className="row">
                  <div className="col s12 txt-left">
                    <table>
                      <tbody>
                        <tr>
                          <td>Customer</td>
                          <td>Status</td>
                          <td>Terms</td>
                          <td>Created/Updated</td>
                        </tr>
                        {renderCustomers(this.props.zohoCustomers)}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="card-action">&nbsp;</div>
            </div>
          </div>
        </div>
        <Modal modalOpen={this.state.modalOpen}>
          <h2>Modal Content</h2>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    zohoCustomers: state.zohoCustomers
  };
}

export default connect(
  mapStateToProps,
  actions
)(Component);
